import BossModel from "@/models/BossModel";
import UniqueSellingPoint from "@/models/Country/UniqueSellingPoint/UniqueSellingPoint";
import InfoLine from "@/models/Country/InfoLine/InfoLine";
import WebsiteCountryInspiration from "@/models/WebsiteCountryInspiration/WebsiteCountryInspiration";
import File from "@/models/File/File";
import IdentityType from "@/models/Country/IdentityType/IdentityType";
import PublicImage from "@/models/PublicImage/PublicImage.js";

export default class Country extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'country';

    /**
     *
     * @type {string}
     */
    static entity = 'countries';

    static fields() {
        return {
            id: this.number(null).nullable(),
            code: this.attr(null),
            code3: this.attr(null),
            iso_numeric: this.attr(null),
            label: this.attr(null),
            url: this.attr(null),
            name: this.attr(null),
            currency_code: this.attr(null),
            currency_name: this.attr(null),
            continent: this.attr(null),
            population: this.attr(null),
            alternatenames: this.attr(null),
            phone_code: this.attr(null),
            capital: this.attr(null),
            is_active: this.attr(null),
            afas_verbation_code: this.attr(null),
            file_id: this.attr(null),
            file_backup_id: this.attr(null),
            proposal_front_file_id: this.attr(null),
            platinum_proposal_front_file_id: this.attr(null),
            is_visible_website: this.boolean(null),
            is_flight_sfi_required: this.boolean(null),
            catalog_rank: this.number(null).nullable(),
            proposal_file_country_url: this.attr(null),
            rank: this.number(null).nullable(),
            website_header_image_id: this.attr(null),
            file: this.belongsTo(File, 'file_id'),
            backupFile: this.belongsTo(File, 'file_backup_id'),
            proposalFrontFile: this.belongsTo(File, 'proposal_front_file_id'),
            platinumProposalFrontFile: this.belongsTo(File, 'platinum_proposal_front_file_id'),
            infoLines: this.hasMany(InfoLine, 'country_id'),
            identityTypes: this.hasMany(IdentityType, 'country_id'),
            uniqueSellingPoints: this.hasMany(UniqueSellingPoint, 'country_id'),
            websiteCountryInspiration: this.hasOne(WebsiteCountryInspiration, 'country_id'),
            websiteHeaderImage: this.belongsTo(PublicImage, 'website_header_image_id')
        }
    }

    /**
     *
     * @param ids
     * @returns {*}
     */
    static byIds(ids) {
        return this.all().filter(item => ids.includes(item.id));
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(20)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new Country(data[key]));
            }

            return instances;
        });
    }

    /**
     *
     * @param params
     * @returns {Promise<TResult>}
     */
    static getByFilters(params = {}) {
        return this.api()
            .filtered(params.filters)
            .paginator(params.paginator)
            .with(params.withs)
            .ordered(params.sortBy)
            .appended(params.appends)
            .get();
    }

    /**
     *
     * @returns {PromiseLike<this> | Promise<this> | *}
     */
    static fetchActiveCountries(){
        return this.api()
            .limit(0)
            .where('is_active', true)
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new Country(data[key]));
            }
            return instances.sort(function(a, b){
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
            })
        });
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    static get(params = {}) {
        return this.api().filtered(params.filters).get();
    }

    /**
     *
     * @param id
     * @param withs
     * @returns {*}
     */
    static loadWith(id, withs = []) {
        return this.api().with(withs).find(id);
    }

    /**
     *
     * @param usps
     * @returns {Promise<AxiosResponse<T>>}
     */
    syncUsps(usps){
        return this.constructor.api().action(this.id + '/sync-usps')
            .update({'usps': usps}).then((country)=> {
            this.UniqueSellingPoints().forEach(usp => usp.destroy());
            if(country.uniqueSellingPoints !== undefined) {
                country.uniqueSellingPoints.forEach(usp => new UniqueSellingPoint(usp).commit());
            }
        });
    }

    /**
     *
     * @returns {*}
     */
    UniqueSellingPoints(){
        return this.getRelated('uniqueSellingPoints');
    }

    /**
     *
     * @returns {*}
     */
    WebsiteCountryInspiration(){
        return this.getRelated('websiteCountryInspiration');
    }

    /**
     *
     * @returns {*}
     */
    InfoLines() {
        return this.getRelated('infoLines');
    }
}
